import React from 'react';
import styled from 'styled-components';
import { screenSmMin, spacer8, spacer16, spacer24, Type, } from '@spotify-internal/encore-web';
import { DELAYS, withAnimationContext, fadeInAnimation, ResponsiveType, TWO_COLUMN_MAX_WIDTH, } from '../../ui';
const QuoteContainer = styled.div `
  padding-top: ${spacer16};
`;
const QuoteCharacter = withAnimationContext(styled(Type.p).attrs({
    weight: 'bold',
}) `
    ${fadeInAnimation(DELAYS.SECOND)};
    font-size: 64px;
    line-height: 24px;
    padding: 0;
    border: 0;
    margin: 0;

    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      line-height: 16px;
    }
  `);
const QuoteBody = withAnimationContext(styled(Type.p).attrs({
    variant: 'ballad',
    weight: 'book',
}) `
    ${fadeInAnimation(DELAYS.THIRD)};
    margin-bottom: ${spacer24};

    @media (min-width: ${screenSmMin}) {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  `);
const Source = withAnimationContext(styled(ResponsiveType).attrs({
    variantDesktop: 'canon',
    variantMobile: 'cello',
}) `
    ${fadeInAnimation(DELAYS.FOURTH)};
    margin-bottom: ${spacer8};
  `);
const JobTitle = withAnimationContext(styled(Type.p).attrs({
    variant: 'finaleBold',
}) `
    ${fadeInAnimation(DELAYS.FIFTH)};
    text-transform: uppercase;
  `);
export const Quote = ({ quote = '', source = '', jobTitle = '', }) => {
    return (React.createElement(QuoteContainer, null,
        React.createElement(QuoteCharacter, null, "\u201C"),
        React.createElement(QuoteBody, null, quote),
        React.createElement(Source, null,
            "\u2014",
            source),
        React.createElement(JobTitle, null, jobTitle)));
};
